import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";

const divRoot: HTMLDivElement = document.querySelector("#ko-program-levels");
const divModel: HTMLDivElement = document.querySelector("#divProgramLevelsModel");

export class Program {
    id: number;
    title: string;
    levels: Level[];

    bgCss: string;
    textCss: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.title = data.title;
        self.levels = _(data.levels).map(x => new Level(x));

        self.bgCss = App.programBgCss(self.id);
        self.textCss = App.programCssText2(self.id);
    }
}

export class Level {
    id: number;
    name: string;
    ageText: string;
    image: string;

    displayInfo = ko.observable(false);
    info = ko.observable<any>();

    showInfo: () => void;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.ageText = data.ageText;
        self.image = "https://cdn.pedalheads.com/images/levels/level-" + data.id + ".jpg";

        self.displayInfo.subscribe(newVal => {
            if (newVal && !self.info()) { self.getInfo(); }
        });

        self.showInfo = () => {
            self.displayInfo(!self.displayInfo());
        }
    }

    private getInfo() {
        let self = this;

        Api.GetSkillLevelInfo(self.id)
            .done(results => {
                if (Api.NoResults("No Skill Level Info Result", results)) { return; }
                self.info(results);
            });
    }
}

export class ViewModel {
    busy = ko.observable(false);
    programs = ko.observableArray<Program>();

    constructor(model: any) {
        let self = this;

        let data = JSON.parse(model);

        let temp = self.programs();
        _(data.programs).each(x => temp.push(new Program(x)));
        self.programs(temp);

        self.busy.subscribe(newVal => App.busy(newVal));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());